module.exports = __webpack_public_path__ + "static/media/syllit_400sc.3245f6ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/sigatoka_negra/curativa/syllit_400sc.png
// module id = 1171
// module chunks = 3